var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',_vm._g({staticClass:"block px-4 py-2 hover:bg-muted-100 dark:hover:bg-muted-600 transition-colors dark:hover:text-white !mb-0 cursor-pointer border-b last:border-0 border-muted-300 dark:border-muted-600"},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }